'use strict';

var toastCtrl = ['$scope', 'toast', '$timeout', function($scope, toast, $timeout) {
    var _this = this;

    this.toast = toast;

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {},
        controller: toastCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'toast-directive/toastDirective.html'
    };
};
